import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const SupportersIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 58,
  height = 58,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g fill="none" fillRule="evenodd" id="supporters" stroke="none" strokeWidth="1">
        <g transform="translate(8.000000, 2.000000)">
          <polygon
            fill="#ffffff"
            className={styles.white}
            points="10.6815 13 29.6815 13 29.6815 0 10.6815 0"
          ></polygon>
          <polygon
            points="10.6815 13 29.6815 13 29.6815 0 10.6815 0"
            stroke="#424242"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2.5"
          ></polygon>
          <line
            stroke="#424242"
            strokeLinecap="round"
            strokeWidth="2.5"
            x1="20.181"
            x2="20.181"
            y1="13.351"
            y2="35.351"
          ></line>
          <line
            stroke="#57B548"
            strokeWidth="1.5"
            x1="13.9369"
            x2="26.5139"
            y1="3.5004"
            y2="3.5004"
          ></line>
          <line
            stroke="#57B548"
            strokeWidth="1.5"
            x1="13.9369"
            x2="26.5139"
            y1="9.5004"
            y2="9.5004"
          ></line>
          <line
            stroke="#57B548"
            strokeWidth="1.5"
            x1="13.9369"
            x2="26.5139"
            y1="6.5004"
            y2="6.5004"
          ></line>
          <g transform="translate(0.000000, 16.995600)">
            <path
              d="M29.692,12.3082 L25.617,25.9692 L29.61,25.9692 L29.61,34.7402 C29.61,35.6322 30.4,36.3552 31.374,36.3552 C32.347,36.3552 33.137,35.6322 33.137,34.7402 L33.137,26.0442 L33.137,34.7402 C33.137,35.6322 33.926,36.3552 34.9,36.3552 C35.874,36.3552 36.663,35.6322 36.663,34.7402 L36.663,25.9692 L40.657,25.9692 L36.696,12.6932 L38.692,19.4632 C39.32,21.4892 42.013,19.9302 41.444,17.9772 L39.541,11.6442 C39.314,10.8132 38.563,9.8802 37.759,9.2452 C36.737,8.4372 35.431,7.9922 34.081,7.9922 L33.137,7.9922 L32.193,7.9922 C30.842,7.9922 29.537,8.4372 28.515,9.2452 C27.71,9.8802 27.119,10.7112 26.808,11.6422 L24.721,17.9632 C23.894,20.3072 26.791,22.0332 27.614,19.2742 L29.692,12.3082 Z"
              fill="#ffffff"
              className={styles.white}
            ></path>
            <path
              d="M29.692,12.3082 L25.617,25.9692 L29.61,25.9692 L29.61,34.7402 C29.61,35.6322 30.4,36.3552 31.374,36.3552 C32.347,36.3552 33.137,35.6322 33.137,34.7402 L33.137,26.0442 L33.137,34.7402 C33.137,35.6322 33.926,36.3552 34.9,36.3552 C35.874,36.3552 36.663,35.6322 36.663,34.7402 L36.663,25.9692 L40.657,25.9692 L36.696,12.6932 L38.692,19.4632 C39.32,21.4892 42.013,19.9302 41.444,17.9772 L39.541,11.6442 C39.314,10.8132 38.563,9.8802 37.759,9.2452 C36.737,8.4372 35.431,7.9922 34.081,7.9922 L33.137,7.9922 L32.193,7.9922 C30.842,7.9922 29.537,8.4372 28.515,9.2452 C27.71,9.8802 27.119,10.7112 26.808,11.6422 L24.721,17.9632 C23.894,20.3072 26.791,22.0332 27.614,19.2742 L29.692,12.3082"
              stroke="#424242"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2.5"
            ></path>
            <path
              d="M36.6082,4.3572 C36.6082,6.3432 35.0522,7.9522 33.1332,7.9522 C31.2142,7.9522 29.6582,6.3432 29.6582,4.3572 C29.6582,2.3712 31.2142,0.7622 33.1332,0.7622 C35.0522,0.7622 36.6082,2.3712 36.6082,4.3572"
              fill="#ffffff"
              className={styles.white}
            ></path>
            <path
              d="M36.6082,4.3572 C36.6082,6.3432 35.0522,7.9522 33.1332,7.9522 C31.2142,7.9522 29.6582,6.3432 29.6582,4.3572 C29.6582,2.3712 31.2142,0.7622 33.1332,0.7622 C35.0522,0.7622 36.6082,2.3712 36.6082,4.3572 Z"
              stroke="#424242"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2.5"
            ></path>
            <path
              d="M4.5052,3.762 C4.5052,5.84 6.1332,7.524 8.1422,7.524 C10.1502,7.524 11.7782,5.84 11.7782,3.762 C11.7782,1.684 10.1502,0 8.1422,0 C6.1332,0 4.5052,1.684 4.5052,3.762"
              fill="#ffffff"
              className={styles.white}
            ></path>
            <path
              d="M4.5052,3.762 C4.5052,5.84 6.1332,7.524 8.1422,7.524 C10.1502,7.524 11.7782,5.84 11.7782,3.762 C11.7782,1.684 10.1502,0 8.1422,0 C6.1332,0 4.5052,1.684 4.5052,3.762 Z"
              stroke="#424242"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2.5"
            ></path>
            <path
              d="M3.526,12.996 L3.526,21.791 C3.526,23.831 0.725,24.399 0.088,22.469 C0.032,22.299 -1.33226763e-15,22.124 -1.33226763e-15,21.946 L-1.33226763e-15,13.517 C-1.33226763e-15,11.096 1.818,8.911 3.891,8.164 C4.953,7.782 6.338,7.524 8.142,7.524 C9.945,7.524 11.33,7.782 12.392,8.164 C14.465,8.911 15.462,10.375 16.886,13.025 L19.461,18.497 C19.829,19.279 19.55,20.223 18.821,20.656 C18.053,21.114 17.072,20.837 16.634,20.04 L12.749,12.996 L12.749,34.566 C12.749,35.554 12.027,36.355 11.138,36.355 L9.743,36.355 C8.851,36.355 8.13,35.552 8.132,34.562 L8.146,23.842 L8.114,34.571 C8.111,35.557 7.391,36.355 6.503,36.355 L5.137,36.355 C4.247,36.355 3.526,35.554 3.526,34.566 L3.526,12.996 Z"
              fill="#ffffff"
              className={styles.white}
            ></path>
            <path
              d="M3.526,12.996 L3.526,21.791 C3.526,23.831 0.725,24.399 0.088,22.469 C0.032,22.299 -1.33226763e-15,22.124 -1.33226763e-15,21.946 L-1.33226763e-15,13.517 C-1.33226763e-15,11.096 1.818,8.911 3.891,8.164 C4.953,7.782 6.338,7.524 8.142,7.524 C9.945,7.524 11.33,7.782 12.392,8.164 C14.465,8.911 15.462,10.375 16.886,13.025 L19.461,18.497 C19.829,19.279 19.55,20.223 18.821,20.656 C18.053,21.114 17.072,20.837 16.634,20.04 L12.749,12.996 L12.749,34.566 C12.749,35.554 12.027,36.355 11.138,36.355 L9.743,36.355 C8.851,36.355 8.13,35.552 8.132,34.562 L8.146,23.842 L8.114,34.571 C8.111,35.557 7.391,36.355 6.503,36.355 L5.137,36.355 C4.247,36.355 3.526,35.554 3.526,34.566 L3.526,12.996 Z"
              stroke="#424242"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2.5"
            ></path>
          </g>
        </g>
      </g>
    </Icon>
  )
}
